import { createSlotRecipe } from './runtime.js';

const chatAttachmentConfig = {"name":"chatAttachment","slots":["root","thumb","overlay"],"variantMap":{"status":["error","uploading"]}}

export const chatAttachment = /* @__PURE__ */ createSlotRecipe(chatAttachmentConfig)